<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title><h2>{{ title }}</h2></v-card-title>
      <v-card-text class="mb-6">{{message}}</v-card-text>
      <v-card-actions class="pr-6 pb-6">
        <v-btn text @click.stop="cancel" id="leftButton">Abbrechen</v-btn>
        <v-btn elevation="0" @click.stop="agree" color="primary" id="rightButton">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDlg",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        width: 400,
        zIndex: 200,
      }
    };
  },

  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.reject(false);
      this.dialog = false;
    }
  }
};
</script>